import { useMemo } from 'react';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIntl } from '@leagueplatform/locales';
import { HeaderNavLink } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useGetCaregiverStatus } from 'hooks/use-get-caregiver-status.hook';

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const { data: isCaregiver } = useGetCaregiverStatus();

  const navLinks = useMemo(
    () =>
      [
        {
          to: APP_MANAGED_ROUTES.HOME,
          label: formatMessage({ id: 'STR_HOME' }),
          icon: 'descriptiveHome',
        },
        {
          to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
          label: formatMessage({ id: 'STR_JOURNEY' }),
          icon: 'capabilityJourney',
        },
        !isCaregiver && {
          to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
          label: formatMessage({ id: 'STR_CARE' }),
          icon: 'descriptivePill',
        },
        {
          to: `${getModulePath(LEAGUE_MODULE_NAMES.liveChat)}/v2`,
          label: formatMessage({ id: 'STR_CARE_COMPANION' }),
          icon: 'descriptiveCaregiver',
        },
      ].filter(Boolean) as HeaderNavLink[],
    [isCaregiver, formatMessage],
  );

  return { navLinks };
};
